import React, { useRef } from 'react';
import {
  IonItemSliding,
  IonItem,
  IonLabel,
} from '@ionic/react';
import { KoStore } from '../models/KoStore';

interface KoStoreListItemProps {
  kostore: KoStore;
  highlightOrderNum?: number;
}

const KoStoreListItem: React.FC<KoStoreListItemProps> = ({
  kostore,
  highlightOrderNum
}) => {
  const ionItemSlidingRef = useRef<HTMLIonItemSlidingElement>(null);
  const isHighlight = kostore.order_num == highlightOrderNum;

  return (
    <IonItemSliding
      ref={ionItemSlidingRef}
      class={'track-' + (kostore.order_num || "")}
    >
      <IonItem
        style={{
          backgroundColor: isHighlight ? '#fff3cd' : '',
          border: isHighlight ? '2px solid red' : ''
        }}
      >
        <IonLabel>
		<p style={{ fontSize: '20px', lineHeight: '30px' }}>
			<span style={{ marginRight: '40px' }}>
			オーダー番号 : {kostore.order_num}
			</span>
			<span style={{ marginRight: '40px' }}>
			RACK_NUM : {kostore.rack_num}
			</span>
			<span>
			ダウンロード : {kostore.download === 0 ? '未' : '済み'}
			</span>
		</p>
        </IonLabel>
      </IonItem>
    </IonItemSliding>
  );
};

export default React.memo(KoStoreListItem);
